import Firebase from 'firebase'
import { getEnvironmentConfig } from './config/environment'

// Firebase configuration loaded from .env file
const envConfig = getEnvironmentConfig()
const config = envConfig.FIREBASE_CONFIG

// Debug: Log Firebase configuration (without sensitive data)
console.log('🔍 Firebase Config Check:')
console.log('  - apiKey:', config && config.apiKey ? config.apiKey.substring(0, 10) + '...' : 'MISSING')
console.log('  - authDomain:', (config && config.authDomain) || 'MISSING')
console.log('  - databaseURL:', (config && config.databaseURL) || 'MISSING')
console.log('  - projectId:', (config && config.projectId) || 'MISSING')
console.log('  - storageBucket:', (config && config.storageBucket) || 'MISSING')
console.log('  - messagingSenderId:', (config && config.messagingSenderId) || 'MISSING')

// Validate Firebase configuration
if (!config || !config.apiKey || !config.databaseURL) {
  console.error('❌ Firebase configuration is missing or incomplete. Please check your .env file.')
  console.error('Required fields: FIREBASE_API_KEY, FIREBASE_DATABASE_URL')
  console.error('Current config:', config)
  
  // Check if process.env values are available (for debugging)
  console.error('Debug - process.env values:')
  console.error('  - FIREBASE_API_KEY:', typeof process.env.FIREBASE_API_KEY !== 'undefined' ? 'EXISTS' : 'MISSING')
  console.error('  - FIREBASE_DATABASE_URL:', typeof process.env.FIREBASE_DATABASE_URL !== 'undefined' ? 'EXISTS' : 'MISSING')
}

let app
let db

try {
  // Try to get existing app first, or initialize new one
  try {
    app = Firebase.app()
    console.log('✅ Using existing Firebase app')
  } catch (e) {
    // No existing app, initialize new one
    app = Firebase.initializeApp(config)
    console.log('✅ Firebase initialized successfully')
  }
  db = app.database()
} catch (error) {
  console.error('❌ Firebase initialization error:', error)
  // Create a mock db object to prevent crashes
  db = {
    ref: () => ({
      once: () => Promise.resolve({ val: () => null }),
      on: () => {},
      off: () => {},
      update: () => Promise.resolve(),
      remove: () => Promise.resolve(),
      set: () => Promise.resolve()
    })
  }
}

export { db }

//function to delete a node from firebase
export function deleteNode(node) {
  db.ref(node).remove().then(r => {
    console.log('Node deleted >>> ' +  node);
  })
}

//delete node from firebase with a key
export function deleteLocationData(runId) {
  db.ref("locations/").child(runId).remove().then(r => {
    console.log('Node deleted >>> ' +  runId);
  })
}



// WEBPACK FOOTER //
// ./src/firebase.js